/**
 * A simple wrapper to handle a list of keys
 */
const onKeys = (...keys) => (callback) => (event) => {
    if (keys.includes(event.key)) {
        event.preventDefault();
        callback?.();
    }
};
/**
 * A simple wrapper to handle space key presses
 */
export const onSpace = onKeys(' ');
/**
 * A simple wrapper to handle space or enter key presses,
 * this emulates the behavior expected by a button role.
 */
export const onSpaceOrEnter = onKeys(' ', 'Enter');
